<template>
  <div class="radio">
    <label
      v-if="label"
      class="select__label"
    >
      {{ label }}
      <span v-if="required" class="select__label-required">*</span>
    </label>
    <div class="radio__items">
      <p
        v-for="(item, itemIndex) in items"
        :key="itemIndex"
        class="radio__item"
      >
        <input
          :id="`radio-${itemIndex + 1}`"
          type="radio"
          name="name"
          :checked="itemIndex === 0"
          @input="change(item)"
        >
        <label
          :for="`radio-${itemIndex + 1}`"
        >
          {{ item.text }}
        </label>
      </p>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['items', 'name', 'label', 'required'],

    mounted () {
      this.change(this.items[0])
    },

    methods: {
      change (item, e) {
        this.$emit('input', item.value)
      }
    }
  }
</script>
<style lang="scss">
  .radio {
    &__items {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -15px;
    }

    &__item {
      padding: 0 15px;
      margin: 5px 0;
      white-space: nowrap;

      @include mobile () {
        flex: 1 1 50%;
      }
    }
  }

  [type="radio"]:checked,
  [type="radio"]:not(:checked) {
    position: absolute;
    left: -9999px;
  }

  [type="radio"]:checked + label,
  [type="radio"]:not(:checked) + label {
    position: relative;
    display: inline-block;
    padding-left: 28px;
    line-height: 20px;
    color: #666;
    cursor: pointer;
  }

  [type="radio"]:checked + label::before,
  [type="radio"]:not(:checked) + label::before {
    position: absolute;
    top: 1px;
    left: 1px;
    width: 18px;
    height: 18px;
    content: '';
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 100%;
  }

  [type="radio"]:checked + label::after,
  [type="radio"]:not(:checked) + label::after {
    position: absolute;
    top: 5px;
    left: 5px;
    width: 10px;
    height: 10px;
    content: '';
    background: $c-active-light;
    border-radius: 100%;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }

  [type="radio"]:not(:checked) + label::after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
  }

  [type="radio"]:checked + label::after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
</style>
